import moment, { Moment } from "moment";
import { isValidMoment } from "../helpers/date_helpers";

export const getFullDayHours = () => {
  /**
   * The order of adding 25 hours.
   * The first hour is 0:00, the last hour is 24:00.
   * The first hour is included in The day we are, the last hour is excluded to the next day.
   *
   */
  const numberOfHours = 25;
  const hoursList = getHoursList(moment().startOf("day"), numberOfHours);
  return hoursList;
};

export function generateFullDayTimeOptions() {
  return getFullDayHours().map((h) => ({
    key: h.format("hh:mm A"),
    value: h.format(),
  }));
}

export function toNormalizedTime(date: Moment) {
  if (!isValidMoment(date)) return null;
  const today = moment();
  return date.date(today.date()).month(today.month()).year(today.year());
}

export const getHoursList = (start: Moment, length: number, step = 60) => {
  if (length < 0) return [];
  return [...Array(length)].map((_, idx) => {
    return toNormalizedTime(start)!
      .clone()
      .add(idx * step, "minutes");
  });
};
